module.exports = __webpack_public_path__ + "img/404.49acd29c.svg";